import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROOF_TYPES, ROOF_CATEGORIES } from "../lib/roofTypes";

export default function RoofTypes() {
  const navigate = useNavigate();
  const [cat, setCat] = useState("All");

  const types = useMemo(() => {
    if (cat === "All") return ROOF_TYPES;
    return ROOF_TYPES.filter((t) => t.category === cat);
  }, [cat]);

  return (
    <div className="p-6 lg:p-10 max-w-[1400px]">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-8">
        <div>
          <span className="hero-rule" />
          <div className="overline">Catalogue</div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight mt-2">Roof Types</h1>
          <p className="text-sm text-slate-500 mt-2">Pick a roof geometry to start a quote. Each style maps to specific calculations.</p>
        </div>
      </div>

      <div className="flex gap-1.5 mb-5 flex-wrap" data-testid="roof-category-filter">
        {["All", ...ROOF_CATEGORIES.map((c) => c.id)].map((c) => (
          <button
            key={c}
            data-testid={`roof-cat-${c}`}
            onClick={() => setCat(c)}
            className={`px-3 py-1.5 text-xs font-semibold uppercase tracking-wider border rounded-sm transition-colors ${
              cat === c ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
        {types.map((t) => {
          const Svg = t.Svg;
          return (
            <button
              key={t.id}
              onClick={() => navigate(`/quotes/new?roof=${t.id}`)}
              className="card-elev p-3 text-left group cursor-pointer hover:border-[var(--rqp-orange)] transition-colors"
              data-testid={`roof-type-${t.id}`}
            >
              <div className="aspect-[4/3] bg-white border border-slate-200 rounded-sm flex items-center justify-center p-1 mb-3 overflow-hidden">
                <Svg s="#1E40AF" a="#D94A31" />
              </div>
              <div className="font-display font-semibold text-sm">{t.name}</div>
              <div className="flex items-center justify-between mt-1">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">{t.category}</div>
                <div className="flex gap-0.5">
                  {[...Array(4)].map((_, i) => (
                    <span key={`bar-${i}`} className={`w-1 h-3 ${i < t.complexity ? "bg-[var(--rqp-orange)]" : "bg-slate-200"}`} />
                  ))}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
